import { el } from 'redom';

import application from 'application';

import '../index.scss';

class SimpleDialogNative {

  constructor(options) {

    this.stackTopClass = (options.stackTopClass || '').trim();
    this.onClose = options.onClose || function noop() {};
    this.contentContainerId = options.contentContainerId || null;
    this.containerClassName = options.containerClassName || '';
    this.contentHolderClassName = options.contentHolderClassName || '';
    this.transparentBackground = options.transparentBackground || false;
    this.content = options.content;
    this.promptMode = options.promptMode === true;
    this.startHidden = options.startHidden === true;
    this.pointerDownStartedInsideContent = false;

    this.centerAlignmentContainer = null;
    this.overflowWrapper = null;
    this.dialogContent = null;
    this.contentHolder = null;

    this.handleWindowPointerUp = this.handleWindowPointerUp.bind(this);

    this.initializeContentHolder();
    this.iniitalizeLayers();

    let cls = '';

    if (this.startHidden === true) {
      cls = 'hidden';
    }

    this.el = el(`.simple-dialog-main dialog-${application.dialogsManager.getActiveDialogsCount()}`, {
      id: this.contentContainerId,
      class: cls
    }, this.dialogContent);

  }

  handleWindowPointerUp() {
    this.pointerDownStartedInsideContent = false;
  }

  onmount() {

    if (this.startHidden === true) {
      return;
    }

    this.incrementActiveDialogsCount();
    this.tryAddStackTopClass();

  }

  onunmount() {
    window.removeEventListener('pointerup', this.handleWindowPointerUp, { passive: true });
    if (this.startHidden === true) {
      return;
    }

    this.tryRemoveStackTopClass();
    this.decrementActiveDialogsCount();

  }

  incrementActiveDialogsCount() {

    application.dialogsManager.incrementActiveDialogsCount();

  }

  decrementActiveDialogsCount() {

    application.dialogsManager.decrementActiveDialogsCount();

  }

  tryAddStackTopClass() {

    const stackTopClass = this.stackTopClass;
    const classNames = ['dialog-is-on'];

    if (stackTopClass.length !== 0) {
      classNames.push(stackTopClass);
    }

    document.body.classList.add(...classNames);

  }

  tryRemoveStackTopClass() {

    const activeDialogsCount = application.dialogsManager.getActiveDialogsCount();
    const stackTopClass = this.stackTopClass;
    const classNames = [];

    if (activeDialogsCount === 1) {
      classNames.push('dialog-is-on');
    }

    if (stackTopClass.length !== 0) {
      classNames.push(stackTopClass.trim());
    }

    document.body.classList.remove(...classNames);

  }

  tryCallOnCloseHandler(event) {

    if (this.promptMode === true) return;

    // If user started the gesture inside content (text selection, drag, etc.), do not close.
    if (this.pointerDownStartedInsideContent === true) {
      this.pointerDownStartedInsideContent = false;
      return;
    }

    if (
      event.target !== this.dialogContent &&
      event.target !== this.centerAlignmentContainer &&
      event.target !== this.overflowWrapper
    ) {
      return;
    }

    event.stopPropagation();
    this.onClose();

  }

  initializeContentHolder() {

    let className = 'simple-dialog-dialog-content-holder ' + this.contentHolderClassName;

    this.contentHolder = el(`.${className}`, [this.content]);

  }

  handleDialogContentPointerDown(event) {

    if (this.promptMode === true) return;

    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    // "inside" means inside the dialog box area (contentHolder)

    this.pointerDownStartedInsideContent = path.includes(this.contentHolder);

  }

  iniitalizeLayers() {

    let containerClass = '';

    if (typeof this.containerClassName === 'string') {
      containerClass = '.' + this.containerClassName;
    }

    this.centerAlignmentContainer = el('.simple-dialog-content-center-alignment-container' + containerClass, this.contentHolder);
    this.overflowWrapper = el('.overflow-wrapper.hide-scrollbar', [this.centerAlignmentContainer]);
    this.dialogContent = el('.simple-dialog-content.hide-scrollbar', [this.overflowWrapper]);

    this.overflowWrapper.addEventListener('pointerup', this.tryCallOnCloseHandler.bind(this));

    this.dialogContent.addEventListener('pointerdown', this.handleDialogContentPointerDown.bind(this), true);

    // safety: reset even if pointerup happens outside your layers
    window.addEventListener('pointerup', this.handleWindowPointerUp, { passive: true });

  }

  show() {

    this.el.classList.remove('hidden');
    this.incrementActiveDialogsCount();
    this.tryAddStackTopClass();

  }

  hide() {

    this.el.classList.add('hidden');
    this.tryRemoveStackTopClass();
    this.decrementActiveDialogsCount();

  }

}

export default SimpleDialogNative;